import styled from 'styled-components';
import { Button, Spacer } from '@perch-labs/shrike';

export const SaveButton = styled(Button).attrs({
  margin: { top: '24px' },
  fullWidth: true,
})``;

export const DeleteButton = styled(Button).attrs({
  margin: { top: '16px' },
  fullWidth: true,
  backgroundless: true,
  color: 'error',
})``;

export const StyledSpacer = styled(Spacer)`
  padding: 24px 0 32px;
`;
